import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFile } from '@/api';
import episodeKeys from '@/queries/episode/episodeKeys';
import camelcaseKeys from 'camelcase-keys';

const transform = (data) => {
    // TODO: Do camelcase transformation in Axios interceptor
    return camelcaseKeys(data, { deep: true });
};

const mutationFn = async ({ episodeId }) => {
    const { data } = await deleteFile(episodeId);

    return transform(data);
};

const useDeleteEpisodeAudioFileMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: (data, { episodeId }) => {
            queryClient.invalidateQueries({
                queryKey: episodeKeys.detailById(episodeId),
            });
        },
    });
};

export default useDeleteEpisodeAudioFileMutation;
